
import { useState, useEffect } from 'react';
import React from 'react';
import './App.css';
//import axios from 'axios';


// import './assets/css/main.css';
// import './assets/css/animate.css'


import {BrowserRouter as Router , Routes, Route , useLocation } from 'react-router-dom';
//import Header from './components/Header/header';
//import HeaderIN from './components/Header/headerIN';
import HeaderAU from './components/Header/headerAU';
//import HeaderUS from './components/Header/headerUS';
//import HeaderGL from './components/Header/header';
//import Footer from './components/footer/footer';
import About from './pages/About/about';
import Home from './pages/Home/home';
import Service from './pages/Service/service';
import Projects from './pages/Projects/projects'
import Socialmedia from './pages/Socialmedia/socialmedia';
import Dgiginite from './pages/Dgiginite/dgiginite';
import Appdevelopment from './pages/Service/subpages/AppDevelopment/appdevelopment';
import Webdevelopment from './pages/Service/subpages/WebDevelopment/webdevelopment';
import Cloudservices from './pages/Service/subpages/CloudServices/cloudservices';
import Automation from './pages/Service/subpages/Automation/automation';
import Migrationservices from './pages/Service/subpages/Migration Services/migrationservices';
import Dataanalytics from './pages/Service/subpages/DataAnalytics/dataanalytics';
import Ecommerce from './pages/Service/subpages/Ecommerce/ecommerce';
import Design from './pages/Service/subpages/DesignWorks/design';
import Seo from './pages/Service/subpages/SEO/seo';
import Erp from './pages/Service/subpages/Erp/erp';
import Crm from './pages/Service/subpages/Crm/crm';
import Microsoft from './pages/Microsoft/Microsoft';
import Career from './pages/Career/career';
import ReturnPolicy from './pages/ReturnPolicy/returnpolicy';
//import FooterIn from './components/footer/footerIN';
//import FooterUs from './components/footer/footerUS';
import FooterAu from './components/footer/footerAU';
import Progress from './components/progressbar/progress';
//import Contact from './pages/Contact/contact';
//import ContactUS from './pages/Contact/contactUS';
import ContactAU from './pages/Contact/contactAU';
//import ContactIN from './pages/Contact/contactIN';
import Privacypolicy from './pages/Privacypolicy/privacypolicy';
import Terms from './pages/Terms_of_Use/terms';
//import ContactFormIN from './components/Contact/contactformIN';
//import ContactFormUS from './components/Contact/contactformUS';
import ContactFormAU from './components/Contact/contactformAU';
import MessengerCustomerChat from 'react-messenger-customer-chat';
//import { ImSpinner9 } from 'react-icons/im';
// import Preloader from './components/Preloder/preloder';
import Scrolltop from './components/Scrollarrow/scrolltop';
import Pagepreloader from './components/Preloder/pagepreloder';
import NDIS from './pages/Ndis/ndis';
import usePageTracking from './Hooks/pageTracking';
import Facebook from './pages/Socialmedia/subpages/Facebook/facebook';
import Instagram from './pages/Socialmedia/subpages/Instagram/instagram';
import Youtube from './pages/Socialmedia/subpages/youtube/youtube';
import SocialForm from './components/Contact/SocialForm';
import ArtificialIntelligence from './pages/Service/subpages/Artificialintelligence/ArtificialIntelligence';
import BlogList from './pages/Blog/bloglist';
import BlogPost from './pages/Blog/blogpost';
import NotFound from './components/NotFound/notfound';
import Boox365Accounting from './pages/Products/Boox365Accounting/Boox365Accounting';
import Boox365Hrms from './pages/Products/Boox365Hrms/Boox365Hrms';
import WeCaaS from './pages/Products/WeCaaS/WeCaaS';

//import Countryselect from './components/Countryselect/countryselect';

const PageTracker = () => { usePageTracking(); return null; };

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const supportsSmooth = 'scrollBehavior' in document.documentElement.style;
    try {
      window.scrollTo(supportsSmooth ? { top: 0, left: 0, behavior: 'smooth' } : 0, 0);
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

function App() {

  
  const pageId = process.env.REACT_APP_FACEBOOK_PAGE_ID;
	const appId = process.env.REACT_APP_FACEBOOK_APP_ID;
  const [loading, setLoading] = useState(false);
 
  //const [userCountry, setUserCountry] = useState(null);
  //const apiToken = process.env.REACT_APP_API_TOKEN;
  //const shouldRenderContactForm = window.location.pathname !== '/contact';
  //const [isLoading, setIsLoading] = useState(true);

  // useEffect(() => {
  //   axios
  //     .get(`https://ipinfo.io?token=${apiToken}`)
  //     .then((response) => {
  //       const data = response.data;
  //       const detectedCountry = data.country;
  //       setUserCountry(detectedCountry);
  //       setTimeout(() => {
  //         setIsLoading(false);
  //     }, 0);
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching user IP information', error);
  //     });
  // }, []);

  useEffect(() => {
    setLoading(true);
    // Simulate an async operation (like data fetching)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500); // Adjust time as needed

    return () => clearTimeout(timer);
  },[]);

  // Determine the header component based on the user's country
  // let HeaderComponent;
  // if (userCountry === 'IN') {
  //   HeaderComponent = <HeaderIN />;
  // } else if (userCountry === 'US') {
  //   HeaderComponent = <HeaderUS />;
  // } else if (userCountry === 'AU') {
  //   HeaderComponent = <HeaderAU />;
  // } else {
  //   // Default header for other countries
  //   HeaderComponent = <HeaderIN />
  // }

  
  // let FooterComponent;
  // if (isLoading) {
  //   FooterComponent = <Pagepreloader/>;
  // } else{
  //   FooterComponent = <FooterAu/>;
  // }

  // let ContactComponent;

  // if (userCountry === 'IN') {
  //   ContactComponent = <ContactIN />;
  // } 
  // else if (userCountry === 'US') 
  // {
  //   ContactComponent = <ContactUS />;
  // } 
  // else if (userCountry === 'AU') 
  // {
  //   ContactComponent = <ContactAU />;
  // } 
  // else {
  //   // Default header for other countries
  //   ContactComponent = <ContactIN/>;
  // }

  // let ContactFormComponent;
  // if (userCountry === 'IN') {
  //   ContactFormComponent = <ContactFormIN />; 
  // } else if (userCountry === 'US') {
  //   ContactFormComponent = <ContactFormUS />; 
  // } else if (userCountry === 'AU') {
  //   ContactFormComponent = <ContactFormAU/>; 
  // } else {
  //   ContactFormComponent = <ContactFormIN/>; 
  // }


  // usePageTracking();
  
  const isSocialMediaPage = () => {
    const currentUrl = window.location.href.toLowerCase();
    return (
      currentUrl.includes("facebook") ||
      currentUrl.includes("youtube") ||
      currentUrl.includes("instagram")
    );
  };
  
  const isContactPage = () => {
    const currentUrl = window.location.href.toLowerCase();
    return (
      currentUrl.includes("contact")||
      currentUrl.includes("terms_of_use") ||
      currentUrl.includes("privacy_policy")
    )
    
  };
  
  const renderForm = () => {
    if (isSocialMediaPage()) {
      return <SocialForm />;
    } else if (isContactPage()) {
      return null;
    } else {
      return <ContactFormAU />;
    }
  }
  return (

    <div className="">
      {loading && <Pagepreloader />}
      <Router>
        <ScrollToTop />
        <PageTracker />
        <Progress/>
      {<HeaderAU/>}
   
        {/* <Header/> */}
        <Routes>
          <Route path='/' element={<Home/>}></Route>
          
          <Route path='about' element={<About/>}></Route>
          <Route path='service' element={<Service/>}></Route>
          {/* sub pages */}
          <Route path='web-design' element={<Webdevelopment/>}></Route>
          <Route path='appdevelopment' element={<Appdevelopment/>}></Route>
          <Route path='cloudservices' element={<Cloudservices/>}></Route>
          <Route path='automation' element={<Automation/>}></Route>
          <Route path='migrationservices' element={<Migrationservices/>}></Route>
          <Route path='dataanalytics' element={<Dataanalytics/>}></Route>
          <Route path='ecommerce' element={<Ecommerce/>}></Route>
          <Route path='design' element={<Design/>}></Route>
          <Route path='seo' element={<Seo/>}></Route>
          <Route path='erp' element={<Erp/>}></Route>
          <Route path='crm' element={<Crm/>}></Route>
          <Route path='artificialintelligence' element={<ArtificialIntelligence/>}></Route>
          <Route path='projects' element={<Projects/>}></Route>
          
          <Route path='socialmedia' element={<Socialmedia/>}></Route>
           {/* sub pages */}
           <Route path="facebook" element={<Facebook />}></Route>
          <Route path="instagram" element={<Instagram />}></Route>
          <Route path="youtube" element={<Youtube />}></Route>
          
          <Route path='dgiginite' element={<Dgiginite/>}></Route>
          
          <Route path='contact' element={<ContactAU/>}></Route>
          
          <Route path='privacy_policy' element={<Privacypolicy/>}></Route>
          <Route path='terms_of_use' element={<Terms/>}></Route>
          <Route path='return_policy' element={<ReturnPolicy/>}></Route>
          <Route path='microsoft' element={<Microsoft/>}></Route>
          <Route path='career' element={<Career/>}></Route>
          <Route path='ndis-website-design' element={<NDIS/>}></Route>
          <Route path='accounting-boox' element={<Boox365Accounting/>}></Route>
          <Route path='hr-boox' element={<Boox365Hrms/>}></Route>
          <Route path='wecaas' element={<WeCaaS/>}></Route>
          <Route path='blog'element={<BlogList/>}></Route>
          <Route path='blog/:slug' element={<BlogPost/>}></Route>
          <Route path='*' element={<NotFound/>}></Route>
         

          {/* <Route path='' element={</>}></Route> */}

        </Routes>
        <Scrolltop/>
        {/* <ContactFormAU/> */}
          {/* {isContactPage() ? null : <ContactFormAU/>} */}
          {renderForm()}
          {/* <Footer/> */}
          <FooterAu/>
          {/* <MessengerCustomerChat
          pageId = {pageId}
          appId={appId}/> */}
      </Router>
    </div>
  );
}

export default App;
